import platform from 'platform';

const OS_NO_SCREEN_SHARING = ['Android', 'iOS'];

const getPlatformInfo = () => ({
    browser: platform.name,
    browserVersion: platform.version,
    os: platform.os.family,
    osVersion: platform.os.version
});

const isSafari = (browser: string = platform.name) => browser === 'Safari';

const isOsNoScreenSharing = (osFamily: string = platform.os.family) => OS_NO_SCREEN_SHARING.includes(osFamily);

export const platformUtils = {
    isSafari,
    isOsNoScreenSharing,
    getPlatformInfo
};